// source: pushwoosh/objects/filters/v1/model.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.Filter', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Application', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Application.TokenPresence', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.Operator', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.Operator', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.Operator', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Geo', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Operation', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.Operator', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Static', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.Operator', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Updated', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.KindCase', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Operator', null, global);
goog.exportSymbol('proto.pushwoosh.objects.filters.v1.__filter_model_internal', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.__filter_model_internal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.__filter_model_internal.displayName = 'proto.pushwoosh.objects.filters.v1.__filter_model_internal';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.Filter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.Filter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.Filter.displayName = 'proto.pushwoosh.objects.filters.v1.Filter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Operation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Operation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Application.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Application, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Application.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Application';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Geo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Geo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Static = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Static.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Static, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Static.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Static';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Updated, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Updated';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.oneofGroups_);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.displayName = 'proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.__filter_model_internal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.__filter_model_internal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal.toObject = function(includeInstance, msg) {
  var f, obj = {
    f1: (f = msg.getF1()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    f2: (f = msg.getF2()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.__filter_model_internal}
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.__filter_model_internal;
  return proto.pushwoosh.objects.filters.v1.__filter_model_internal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.__filter_model_internal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.__filter_model_internal}
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setF1(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setF2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.__filter_model_internal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.__filter_model_internal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getF1();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getF2();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue f1 = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal.prototype.getF1 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.__filter_model_internal} returns this
*/
proto.pushwoosh.objects.filters.v1.__filter_model_internal.prototype.setF1 = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.__filter_model_internal} returns this
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal.prototype.clearF1 = function() {
  return this.setF1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal.prototype.hasF1 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp f2 = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal.prototype.getF2 = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.__filter_model_internal} returns this
*/
proto.pushwoosh.objects.filters.v1.__filter_model_internal.prototype.setF2 = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.__filter_model_internal} returns this
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal.prototype.clearF2 = function() {
  return this.setF2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.__filter_model_internal.prototype.hasF2 = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.Filter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.Filter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.Filter.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    code: jspb.Message.getFieldWithDefault(msg, 12, ""),
    accountid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 13, ""),
    applicationid: (f = msg.getApplicationid()) && google_protobuf_wrappers_pb.UInt64Value.toObject(includeInstance, f),
    isfiltrationinprogress: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    filtrationstartedat: (f = msg.getFiltrationstartedat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    filtrationlastfilteredat: (f = msg.getFiltrationlastfilteredat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    filtrationlastcheckedat: (f = msg.getFiltrationlastcheckedat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    filtrationscheduledat: (f = msg.getFiltrationscheduledat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    checkerscheduledat: (f = msg.getCheckerscheduledat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    issystem: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    expirationdate: (f = msg.getExpirationdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    filterexpressionraw: jspb.Message.getFieldWithDefault(msg, 18, ""),
    filtrationid: (f = msg.getFiltrationid()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    updated: (f = msg.getUpdated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.Filter}
 */
proto.pushwoosh.objects.filters.v1.Filter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.Filter;
  return proto.pushwoosh.objects.filters.v1.Filter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.Filter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.Filter}
 */
proto.pushwoosh.objects.filters.v1.Filter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAccountid(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.UInt64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.UInt64Value.deserializeBinaryFromReader);
      msg.setApplicationid(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsfiltrationinprogress(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFiltrationstartedat(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFiltrationlastfilteredat(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFiltrationlastcheckedat(value);
      break;
    case 16:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFiltrationscheduledat(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCheckerscheduledat(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssystem(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpirationdate(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilterexpressionraw(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setFiltrationid(value);
      break;
    case 19:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.Filter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.Filter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.Filter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAccountid();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getApplicationid();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.UInt64Value.serializeBinaryToWriter
    );
  }
  f = message.getIsfiltrationinprogress();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getFiltrationstartedat();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFiltrationlastfilteredat();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFiltrationlastcheckedat();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFiltrationscheduledat();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCheckerscheduledat();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIssystem();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getExpirationdate();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFilterexpressionraw();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getFiltrationid();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUpdated();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 ID = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Code = 12;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional uint64 AccountID = 2;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getAccountid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Name = 13;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional google.protobuf.UInt64Value ApplicationID = 5;
 * @return {?proto.google.protobuf.UInt64Value}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getApplicationid = function() {
  return /** @type{?proto.google.protobuf.UInt64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.UInt64Value, 5));
};


/**
 * @param {?proto.google.protobuf.UInt64Value|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
*/
proto.pushwoosh.objects.filters.v1.Filter.prototype.setApplicationid = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.clearApplicationid = function() {
  return this.setApplicationid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.hasApplicationid = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool IsFiltrationInProgress = 6;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getIsfiltrationinprogress = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.setIsfiltrationinprogress = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp FiltrationStartedAt = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getFiltrationstartedat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
*/
proto.pushwoosh.objects.filters.v1.Filter.prototype.setFiltrationstartedat = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.clearFiltrationstartedat = function() {
  return this.setFiltrationstartedat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.hasFiltrationstartedat = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp FiltrationLastFilteredAt = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getFiltrationlastfilteredat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
*/
proto.pushwoosh.objects.filters.v1.Filter.prototype.setFiltrationlastfilteredat = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.clearFiltrationlastfilteredat = function() {
  return this.setFiltrationlastfilteredat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.hasFiltrationlastfilteredat = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Timestamp FiltrationLastCheckedAt = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getFiltrationlastcheckedat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
*/
proto.pushwoosh.objects.filters.v1.Filter.prototype.setFiltrationlastcheckedat = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.clearFiltrationlastcheckedat = function() {
  return this.setFiltrationlastcheckedat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.hasFiltrationlastcheckedat = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.Timestamp FiltrationScheduledAt = 16;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getFiltrationscheduledat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 16));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
*/
proto.pushwoosh.objects.filters.v1.Filter.prototype.setFiltrationscheduledat = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.clearFiltrationscheduledat = function() {
  return this.setFiltrationscheduledat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.hasFiltrationscheduledat = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.Timestamp CheckerScheduledAt = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getCheckerscheduledat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
*/
proto.pushwoosh.objects.filters.v1.Filter.prototype.setCheckerscheduledat = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.clearCheckerscheduledat = function() {
  return this.setCheckerscheduledat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.hasCheckerscheduledat = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional bool IsSystem = 8;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getIssystem = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.setIssystem = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp ExpirationDate = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getExpirationdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
*/
proto.pushwoosh.objects.filters.v1.Filter.prototype.setExpirationdate = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.clearExpirationdate = function() {
  return this.setExpirationdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.hasExpirationdate = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp Created = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
*/
proto.pushwoosh.objects.filters.v1.Filter.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string FilterExpressionRaw = 18;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getFilterexpressionraw = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.setFilterexpressionraw = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional google.protobuf.StringValue FiltrationID = 20;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getFiltrationid = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 20));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
*/
proto.pushwoosh.objects.filters.v1.Filter.prototype.setFiltrationid = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.clearFiltrationid = function() {
  return this.setFiltrationid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.hasFiltrationid = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.Timestamp Updated = 19;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.getUpdated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 19));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
*/
proto.pushwoosh.objects.filters.v1.Filter.prototype.setUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.Filter} returns this
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.clearUpdated = function() {
  return this.setUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.Filter.prototype.hasUpdated = function() {
  return jspb.Message.getField(this, 19) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.oneofGroups_ = [[1,2,3,4,5,6,7,8,9]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.KindCase = {
  KIND_NOT_SET: 0,
  OPERATION: 1,
  APPLICATION: 2,
  TAG: 3,
  GEO: 4,
  STATIC: 5,
  EVENT: 6,
  UPDATED: 7,
  BEST_TIME_TO_SEND: 8,
  TAG_DATE_MATCH: 9
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.toObject = function(includeInstance, msg) {
  var f, obj = {
    operation: (f = msg.getOperation()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.toObject(includeInstance, f),
    application: (f = msg.getApplication()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Application.toObject(includeInstance, f),
    tag: (f = msg.getTag()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.toObject(includeInstance, f),
    geo: (f = msg.getGeo()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.toObject(includeInstance, f),
    pb_static: (f = msg.getStatic()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Static.toObject(includeInstance, f),
    event: (f = msg.getEvent()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.toObject(includeInstance, f),
    updated: (f = msg.getUpdated()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.toObject(includeInstance, f),
    bestTimeToSend: (f = msg.getBestTimeToSend()) && proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.toObject(includeInstance, f),
    tagDateMatch: (f = msg.getTagDateMatch()) && proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Operation;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.deserializeBinaryFromReader);
      msg.setOperation(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Application;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Application.deserializeBinaryFromReader);
      msg.setApplication(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.deserializeBinaryFromReader);
      msg.setTag(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Geo;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.deserializeBinaryFromReader);
      msg.setGeo(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Static;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Static.deserializeBinaryFromReader);
      msg.setStatic(value);
      break;
    case 6:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    case 7:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Updated;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.deserializeBinaryFromReader);
      msg.setUpdated(value);
      break;
    case 8:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.deserializeBinaryFromReader);
      msg.setBestTimeToSend(value);
      break;
    case 9:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.deserializeBinaryFromReader);
      msg.setTagDateMatch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.serializeBinaryToWriter
    );
  }
  f = message.getApplication();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Application.serializeBinaryToWriter
    );
  }
  f = message.getTag();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.serializeBinaryToWriter
    );
  }
  f = message.getGeo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.serializeBinaryToWriter
    );
  }
  f = message.getStatic();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Static.serializeBinaryToWriter
    );
  }
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.serializeBinaryToWriter
    );
  }
  f = message.getUpdated();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.serializeBinaryToWriter
    );
  }
  f = message.getBestTimeToSend();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.serializeBinaryToWriter
    );
  }
  f = message.getTagDateMatch();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Operation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.toObject = function(includeInstance, msg) {
  var f, obj = {
    operator: jspb.Message.getFieldWithDefault(msg, 1, 0),
    operandsList: jspb.Message.toObjectList(msg.getOperandsList(),
    proto.pushwoosh.objects.filters.v1.FilterExpression.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Operation}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Operation;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Operation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Operation}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.Operator} */ (reader.readEnum());
      msg.setOperator(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.deserializeBinaryFromReader);
      msg.addOperands(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Operation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperator();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getOperandsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.Operator = {
  OPERATOR_UNSPECIFIED: 0,
  OPERATOR_INTERSECT: 1,
  OPERATOR_UNION: 2,
  OPERATOR_DIFFERENCE: 3
};

/**
 * optional Operator operator = 1;
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.Operator}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.prototype.getOperator = function() {
  return /** @type {!proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.Operator} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.Operator} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Operation} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.prototype.setOperator = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated FilterExpression operands = 2;
 * @return {!Array<!proto.pushwoosh.objects.filters.v1.FilterExpression>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.prototype.getOperandsList = function() {
  return /** @type{!Array<!proto.pushwoosh.objects.filters.v1.FilterExpression>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression, 2));
};


/**
 * @param {!Array<!proto.pushwoosh.objects.filters.v1.FilterExpression>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Operation} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.prototype.setOperandsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.prototype.addOperands = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.pushwoosh.objects.filters.v1.FilterExpression, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Operation} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Operation.prototype.clearOperandsList = function() {
  return this.setOperandsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Application.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.toObject = function(includeInstance, msg) {
  var f, obj = {
    codesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    platformsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    tokenPresence: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Application;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Application.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addCodes(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPlatforms(values[i]);
      }
      break;
    case 3:
      var value = /** @type {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application.TokenPresence} */ (reader.readEnum());
      msg.setTokenPresence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Application.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getPlatformsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      2,
      f
    );
  }
  f = message.getTokenPresence();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.TokenPresence = {
  TOKEN_PRESENCE_UNSPECIFIED: 0,
  TOKEN_PRESENCE_WITH_TOKENS: 1,
  TOKEN_PRESENCE_WITHOUT_TOKENS: 2,
  TOKEN_PRESENCE_ALL: 3
};

/**
 * repeated string codes = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.prototype.getCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.prototype.setCodesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.prototype.addCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.prototype.clearCodesList = function() {
  return this.setCodesList([]);
};


/**
 * repeated uint32 platforms = 2;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.prototype.getPlatformsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.prototype.setPlatformsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.prototype.addPlatforms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.prototype.clearPlatformsList = function() {
  return this.setPlatformsList([]);
};


/**
 * optional TokenPresence token_presence = 3;
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application.TokenPresence}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.prototype.getTokenPresence = function() {
  return /** @type {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application.TokenPresence} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application.TokenPresence} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Application} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Application.prototype.setTokenPresence = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Geo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.toObject = function(includeInstance, msg) {
  var f, obj = {
    application: jspb.Message.getFieldWithDefault(msg, 1, ""),
    lat: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    lon: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    range: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Geo}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Geo;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Geo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Geo}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplication(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLat(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLon(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Geo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLat();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getLon();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getRange();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional string application = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.prototype.getApplication = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Geo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.prototype.setApplication = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double lat = 2;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.prototype.getLat = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Geo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.prototype.setLat = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double lon = 3;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.prototype.getLon = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Geo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.prototype.setLon = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double range = 4;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.prototype.getRange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Geo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Geo.prototype.setRange = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    value: (f = msg.getValue()) && proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addApplications(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  LTE: 3,
  GTE: 4,
  ANY: 5
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.toObject(includeInstance, f),
    lte: (f = msg.getLte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.toObject(includeInstance, f),
    gte: (f = msg.getGte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.toObject(includeInstance, f),
    any: (f = msg.getAny()) && proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.deserializeBinaryFromReader);
      msg.setLte(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.deserializeBinaryFromReader);
      msg.setGte(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.deserializeBinaryFromReader);
      msg.setAny(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.serializeBinaryToWriter
    );
  }
  f = message.getLte();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.serializeBinaryToWriter
    );
  }
  f = message.getGte();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.serializeBinaryToWriter
    );
  }
  f = message.getAny();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Lte lte = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.getLte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Lte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.setLte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.clearLte = function() {
  return this.setLte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.hasLte = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Gte gte = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.getGte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Gte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.setGte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.clearGte = function() {
  return this.setGte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.hasGte = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Any any = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.getAny = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.Any|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.setAny = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.clearAny = function() {
  return this.setAny(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value.prototype.hasAny = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated string applications = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.prototype.getApplicationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.prototype.setApplicationsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.prototype.addApplications = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.prototype.clearApplicationsList = function() {
  return this.setApplicationsList([]);
};


/**
 * optional Value value = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.prototype.getValue = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.Value|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend.prototype.hasValue = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Static.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Static.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Static.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Static} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Static.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Static}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Static.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Static;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Static.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Static} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Static}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Static.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Static.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Static.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Static} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Static.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Static.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Static} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Static.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Static} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Static.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Static} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Static.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.toObject = function(includeInstance, msg) {
  var f, obj = {
    application: jspb.Message.getFieldWithDefault(msg, 1, ""),
    event: jspb.Message.getFieldWithDefault(msg, 2, ""),
    count: (f = msg.getCount()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.toObject(includeInstance, f),
    date: (f = msg.getDate()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.toObject(includeInstance, f),
    attributesList: jspb.Message.toObjectList(msg.getAttributesList(),
    proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.toObject, includeInstance),
    platformsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplication(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvent(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.deserializeBinaryFromReader);
      msg.setCount(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.deserializeBinaryFromReader);
      msg.addAttributes(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addPlatforms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEvent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.serializeBinaryToWriter
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.serializeBinaryToWriter
    );
  }
  f = message.getAttributesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.serializeBinaryToWriter
    );
  }
  f = message.getPlatformsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.toObject = function(includeInstance, msg) {
  var f, obj = {
    operator: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.Operator} */ (reader.readEnum());
      msg.setOperator(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperator();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.Operator = {
  OPERATOR_UNSPECIFIED: 0,
  OPERATOR_EQ: 1,
  OPERATOR_NEQ: 2,
  OPERATOR_LTE: 4,
  OPERATOR_GTE: 6
};

/**
 * optional Operator operator = 1;
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.Operator}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.prototype.getOperator = function() {
  return /** @type {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.Operator} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.Operator} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.prototype.setOperator = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional uint64 value = 2;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.oneofGroups_ = [[1,2,3,4,5,6,7,8,9]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  LTE: 3,
  GTE: 4,
  IN: 5,
  NOT_IN: 6,
  BETWEEN: 7,
  EXISTS: 8,
  DAYS_AGO: 9
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.toObject(includeInstance, f),
    lte: (f = msg.getLte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.toObject(includeInstance, f),
    gte: (f = msg.getGte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.toObject(includeInstance, f),
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.toObject(includeInstance, f),
    between: (f = msg.getBetween()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.toObject(includeInstance, f),
    daysAgo: (f = msg.getDaysAgo()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.deserializeBinaryFromReader);
      msg.setLte(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.deserializeBinaryFromReader);
      msg.setGte(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 6:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 7:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.deserializeBinaryFromReader);
      msg.setBetween(value);
      break;
    case 8:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    case 9:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.deserializeBinaryFromReader);
      msg.setDaysAgo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.serializeBinaryToWriter
    );
  }
  f = message.getLte();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.serializeBinaryToWriter
    );
  }
  f = message.getGte();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.serializeBinaryToWriter
    );
  }
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getBetween();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.serializeBinaryToWriter
    );
  }
  f = message.getDaysAgo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated google.protobuf.Timestamp values = 1;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated google.protobuf.Timestamp values = 1;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp from = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.prototype.getFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp to = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.prototype.getTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between.prototype.hasTo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.toObject = function(includeInstance, msg) {
  var f, obj = {
    operator: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, 0),
    valuesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.Operator} */ (reader.readEnum());
      msg.setOperator(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperator();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.Operator = {
  OPERATOR_UNSPECIFIED: 0,
  OPERATOR_EQ: 1,
  OPERATOR_NEQ: 2,
  OPERATOR_LTE: 3,
  OPERATOR_GTE: 4,
  OPERATOR_BETWEEN: 5
};

/**
 * optional Operator operator = 1;
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.Operator}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.prototype.getOperator = function() {
  return /** @type {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.Operator} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.Operator} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.prototype.setOperator = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 value = 2;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated int32 values = 3;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Lte lte = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.getLte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Lte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.setLte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.clearLte = function() {
  return this.setLte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.hasLte = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Gte gte = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.getGte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Gte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.setGte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.clearGte = function() {
  return this.setGte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.hasGte = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional In in = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.hasIn = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional NotIn not_in = 6;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn, 6));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Between between = 7;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.getBetween = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between, 7));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Between|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.setBetween = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.clearBetween = function() {
  return this.setBetween(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.hasBetween = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Exists exists = 8;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists, 8));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.hasExists = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional DaysAgo days_ago = 9;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.getDaysAgo = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo, 9));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.DaysAgo|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.setDaysAgo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.clearDaysAgo = function() {
  return this.setDaysAgo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date.prototype.hasDaysAgo = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.oneofGroups_ = [[10,11,12,13,14,15]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.KindCase = {
  KIND_NOT_SET: 0,
  INTEGER: 10,
  STRING: 11,
  LIST: 12,
  DATE: 13,
  BOOLEAN: 14,
  PRICE: 15
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    integer: (f = msg.getInteger()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.toObject(includeInstance, f),
    string: (f = msg.getString()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.toObject(includeInstance, f),
    list: (f = msg.getList()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.toObject(includeInstance, f),
    date: (f = msg.getDate()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.toObject(includeInstance, f),
    pb_boolean: (f = msg.getBoolean()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.toObject(includeInstance, f),
    price: (f = msg.getPrice()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 10:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.deserializeBinaryFromReader);
      msg.setInteger(value);
      break;
    case 11:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.deserializeBinaryFromReader);
      msg.setString(value);
      break;
    case 12:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.deserializeBinaryFromReader);
      msg.setList(value);
      break;
    case 13:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 14:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.deserializeBinaryFromReader);
      msg.setBoolean(value);
      break;
    case 15:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInteger();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.serializeBinaryToWriter
    );
  }
  f = message.getString();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.serializeBinaryToWriter
    );
  }
  f = message.getList();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.serializeBinaryToWriter
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.serializeBinaryToWriter
    );
  }
  f = message.getBoolean();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.oneofGroups_ = [[1,2,3,4,5,6,7,8]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  LTE: 3,
  GTE: 4,
  IN: 5,
  NOT_IN: 6,
  BETWEEN: 7,
  EXISTS: 8
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.toObject(includeInstance, f),
    lte: (f = msg.getLte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.toObject(includeInstance, f),
    gte: (f = msg.getGte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.toObject(includeInstance, f),
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.toObject(includeInstance, f),
    between: (f = msg.getBetween()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.deserializeBinaryFromReader);
      msg.setLte(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.deserializeBinaryFromReader);
      msg.setGte(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 6:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 7:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.deserializeBinaryFromReader);
      msg.setBetween(value);
      break;
    case 8:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.serializeBinaryToWriter
    );
  }
  f = message.getLte();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.serializeBinaryToWriter
    );
  }
  f = message.getGte();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.serializeBinaryToWriter
    );
  }
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getBetween();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedInt64(
      1,
      f
    );
  }
};


/**
 * repeated int64 values = 1;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedInt64(
      1,
      f
    );
  }
};


/**
 * repeated int64 values = 1;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: jspb.Message.getFieldWithDefault(msg, 1, 0),
    to: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTo();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 from = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.prototype.getFrom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.prototype.setFrom = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 to = 2;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.prototype.getTo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between.prototype.setTo = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Lte lte = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.getLte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Lte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.setLte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.clearLte = function() {
  return this.setLte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.hasLte = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Gte gte = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.getGte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Gte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.setGte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.clearGte = function() {
  return this.setGte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.hasGte = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional In in = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.hasIn = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional NotIn not_in = 6;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn, 6));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Between between = 7;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.getBetween = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between, 7));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Between|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.setBetween = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.clearBetween = function() {
  return this.setBetween(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.hasBetween = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Exists exists = 8;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists, 8));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer.prototype.hasExists = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.oneofGroups_ = [[1,2,3,4,5,6,7,8]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  IN: 3,
  NOT_IN: 4,
  EXISTS: 5,
  STARTS_WITH: 6,
  ENDS_WITH: 7,
  CONTAINS: 8
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.toObject(includeInstance, f),
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.toObject(includeInstance, f),
    startsWith: (f = msg.getStartsWith()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.toObject(includeInstance, f),
    endsWith: (f = msg.getEndsWith()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.toObject(includeInstance, f),
    contains: (f = msg.getContains()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    case 6:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.deserializeBinaryFromReader);
      msg.setStartsWith(value);
      break;
    case 7:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.deserializeBinaryFromReader);
      msg.setEndsWith(value);
      break;
    case 8:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.deserializeBinaryFromReader);
      msg.setContains(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.serializeBinaryToWriter
    );
  }
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.serializeBinaryToWriter
    );
  }
  f = message.getStartsWith();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.serializeBinaryToWriter
    );
  }
  f = message.getEndsWith();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.serializeBinaryToWriter
    );
  }
  f = message.getContains();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional In in = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.hasIn = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional NotIn not_in = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Exists exists = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.hasExists = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional StartsWith starts_with = 6;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.getStartsWith = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith, 6));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.StartsWith|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.setStartsWith = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.clearStartsWith = function() {
  return this.setStartsWith(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.hasStartsWith = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional EndsWith ends_with = 7;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.getEndsWith = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith, 7));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.EndsWith|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.setEndsWith = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.clearEndsWith = function() {
  return this.setEndsWith(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.hasEndsWith = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Contains contains = 8;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.getContains = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains, 8));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.Contains|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.setContains = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.clearContains = function() {
  return this.setContains(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String.prototype.hasContains = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.oneofGroups_ = [[3,4,5]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.KindCase = {
  KIND_NOT_SET: 0,
  IN: 3,
  NOT_IN: 4,
  EXISTS: 5
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.toObject = function(includeInstance, msg) {
  var f, obj = {
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional In in = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.hasIn = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional NotIn not_in = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Exists exists = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List.prototype.hasExists = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.oneofGroups_ = [[1,2,3,4,5,6,7,8,9]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  LTE: 3,
  GTE: 4,
  IN: 5,
  NOT_IN: 6,
  BETWEEN: 7,
  EXISTS: 8,
  DAYS_AGO: 9
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.toObject(includeInstance, f),
    lte: (f = msg.getLte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.toObject(includeInstance, f),
    gte: (f = msg.getGte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.toObject(includeInstance, f),
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.toObject(includeInstance, f),
    between: (f = msg.getBetween()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.toObject(includeInstance, f),
    daysAgo: (f = msg.getDaysAgo()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.deserializeBinaryFromReader);
      msg.setLte(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.deserializeBinaryFromReader);
      msg.setGte(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 6:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 7:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.deserializeBinaryFromReader);
      msg.setBetween(value);
      break;
    case 8:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    case 9:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.deserializeBinaryFromReader);
      msg.setDaysAgo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.serializeBinaryToWriter
    );
  }
  f = message.getLte();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.serializeBinaryToWriter
    );
  }
  f = message.getGte();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.serializeBinaryToWriter
    );
  }
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getBetween();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.serializeBinaryToWriter
    );
  }
  f = message.getDaysAgo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated google.protobuf.Timestamp values = 1;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated google.protobuf.Timestamp values = 1;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp from = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.prototype.getFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp to = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.prototype.getTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between.prototype.hasTo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.toObject = function(includeInstance, msg) {
  var f, obj = {
    operator: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, 0),
    valuesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.Operator} */ (reader.readEnum());
      msg.setOperator(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperator();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.Operator = {
  OPERATOR_UNSPECIFIED: 0,
  OPERATOR_EQ: 1,
  OPERATOR_NEQ: 2,
  OPERATOR_LTE: 3,
  OPERATOR_GTE: 4,
  OPERATOR_BETWEEN: 5
};

/**
 * optional Operator operator = 1;
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.Operator}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.prototype.getOperator = function() {
  return /** @type {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.Operator} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.Operator} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.prototype.setOperator = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 value = 2;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated int32 values = 3;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Lte lte = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.getLte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Lte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.setLte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.clearLte = function() {
  return this.setLte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.hasLte = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Gte gte = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.getGte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Gte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.setGte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.clearGte = function() {
  return this.setGte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.hasGte = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional In in = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.hasIn = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional NotIn not_in = 6;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn, 6));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Between between = 7;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.getBetween = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between, 7));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Between|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.setBetween = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.clearBetween = function() {
  return this.setBetween(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.hasBetween = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Exists exists = 8;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists, 8));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.hasExists = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional DaysAgo days_ago = 9;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.getDaysAgo = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo, 9));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.DaysAgo|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.setDaysAgo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.clearDaysAgo = function() {
  return this.setDaysAgo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date.prototype.hasDaysAgo = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  EXISTS: 3
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool value = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool value = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Exists exists = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean.prototype.hasExists = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.oneofGroups_ = [[1,2,3,4,5,6,7,8]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  LTE: 3,
  GTE: 4,
  IN: 5,
  NOT_IN: 6,
  BETWEEN: 7,
  EXISTS: 8
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.toObject(includeInstance, f),
    lte: (f = msg.getLte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.toObject(includeInstance, f),
    gte: (f = msg.getGte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.toObject(includeInstance, f),
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.toObject(includeInstance, f),
    between: (f = msg.getBetween()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.deserializeBinaryFromReader);
      msg.setLte(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.deserializeBinaryFromReader);
      msg.setGte(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 6:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 7:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.deserializeBinaryFromReader);
      msg.setBetween(value);
      break;
    case 8:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.serializeBinaryToWriter
    );
  }
  f = message.getLte();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.serializeBinaryToWriter
    );
  }
  f = message.getGte();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.serializeBinaryToWriter
    );
  }
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getBetween();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedDouble() : [reader.readDouble()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedDouble(
      1,
      f
    );
  }
};


/**
 * repeated double values = 1;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedDouble() : [reader.readDouble()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedDouble(
      1,
      f
    );
  }
};


/**
 * repeated double values = 1;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    to: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getTo();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double from = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.prototype.getFrom = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.prototype.setFrom = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double to = 2;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.prototype.getTo = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between.prototype.setTo = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Lte lte = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.getLte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Lte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.setLte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.clearLte = function() {
  return this.setLte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.hasLte = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Gte gte = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.getGte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Gte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.setGte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.clearGte = function() {
  return this.setGte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.hasGte = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional In in = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.hasIn = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional NotIn not_in = 6;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn, 6));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Between between = 7;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.getBetween = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between, 7));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Between|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.setBetween = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.clearBetween = function() {
  return this.setBetween(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.hasBetween = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Exists exists = 8;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists, 8));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price.prototype.hasExists = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Integer integer = 10;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.getInteger = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer, 10));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Integer|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.setInteger = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.clearInteger = function() {
  return this.setInteger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.hasInteger = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional String string = 11;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.getString = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String, 11));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.String|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.setString = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.clearString = function() {
  return this.setString(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.hasString = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional List list = 12;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.getList = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List, 12));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.List|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.setList = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.clearList = function() {
  return this.setList(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.hasList = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Date date = 13;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.getDate = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date, 13));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Date|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.setDate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.hasDate = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Boolean boolean = 14;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.getBoolean = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean, 14));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Boolean|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.setBoolean = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.clearBoolean = function() {
  return this.setBoolean(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.hasBoolean = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional Price price = 15;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.getPrice = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price, 15));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.Price|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.setPrice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string application = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.getApplication = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.setApplication = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string event = 2;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.getEvent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.setEvent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Count count = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.getCount = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Count|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.setCount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.clearCount = function() {
  return this.setCount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.hasCount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Date date = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.getDate = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Date|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.hasDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated Attribute attributes = 5;
 * @return {!Array<!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.getAttributesList = function() {
  return /** @type{!Array<!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute, 5));
};


/**
 * @param {!Array<!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.setAttributesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.addAttributes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.pushwoosh.objects.filters.v1.FilterExpression.Event.Attribute, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.clearAttributesList = function() {
  return this.setAttributesList([]);
};


/**
 * repeated string platforms = 6;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.getPlatformsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.setPlatformsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.addPlatforms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Event} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Event.prototype.clearPlatformsList = function() {
  return this.setPlatformsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.toObject = function(includeInstance, msg) {
  var f, obj = {
    application: jspb.Message.getFieldWithDefault(msg, 1, ""),
    condition: (f = msg.getCondition()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Updated;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplication(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.deserializeBinaryFromReader);
      msg.setCondition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCondition();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.KindCase = {
  KIND_NOT_SET: 0,
  LTE: 1,
  GTE: 2,
  BETWEEN: 3
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.toObject = function(includeInstance, msg) {
  var f, obj = {
    lte: (f = msg.getLte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.toObject(includeInstance, f),
    gte: (f = msg.getGte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.toObject(includeInstance, f),
    between: (f = msg.getBetween()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.deserializeBinaryFromReader);
      msg.setLte(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.deserializeBinaryFromReader);
      msg.setGte(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.deserializeBinaryFromReader);
      msg.setBetween(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLte();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.serializeBinaryToWriter
    );
  }
  f = message.getGte();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.serializeBinaryToWriter
    );
  }
  f = message.getBetween();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Operator = {
  OPERATOR_UNSPECIFIED: 0,
  OPERATOR_LTE: 1,
  OPERATOR_GTE: 2,
  OPERATOR_BETWEEN: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp from = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.prototype.getFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp to = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.prototype.getTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between.prototype.hasTo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Lte lte = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.getLte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Lte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.setLte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.clearLte = function() {
  return this.setLte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.hasLte = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Gte gte = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.getGte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Gte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.setGte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.clearGte = function() {
  return this.setGte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.hasGte = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Between between = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.getBetween = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.Between|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.setBetween = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.clearBetween = function() {
  return this.setBetween(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition.prototype.hasBetween = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string application = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.prototype.getApplication = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.prototype.setApplication = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Condition condition = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.prototype.getCondition = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.Condition|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.prototype.setCondition = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Updated} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.prototype.clearCondition = function() {
  return this.setCondition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Updated.prototype.hasCondition = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.oneofGroups_ = [[10,11,12,13,14,15,16,17]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.KindCase = {
  KIND_NOT_SET: 0,
  INTEGER: 10,
  STRING: 11,
  LIST: 12,
  DATE: 13,
  BOOLEAN: 14,
  PRICE: 15,
  VERSION: 16,
  TIMEZONE: 17
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    application: jspb.Message.getFieldWithDefault(msg, 2, ""),
    integer: (f = msg.getInteger()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.toObject(includeInstance, f),
    string: (f = msg.getString()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.toObject(includeInstance, f),
    list: (f = msg.getList()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.toObject(includeInstance, f),
    date: (f = msg.getDate()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.toObject(includeInstance, f),
    pb_boolean: (f = msg.getBoolean()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.toObject(includeInstance, f),
    price: (f = msg.getPrice()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.toObject(includeInstance, f),
    version: (f = msg.getVersion()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.toObject(includeInstance, f),
    timezone: (f = msg.getTimezone()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplication(value);
      break;
    case 10:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.deserializeBinaryFromReader);
      msg.setInteger(value);
      break;
    case 11:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.deserializeBinaryFromReader);
      msg.setString(value);
      break;
    case 12:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.deserializeBinaryFromReader);
      msg.setList(value);
      break;
    case 13:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 14:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.deserializeBinaryFromReader);
      msg.setBoolean(value);
      break;
    case 15:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 16:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.deserializeBinaryFromReader);
      msg.setVersion(value);
      break;
    case 17:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.deserializeBinaryFromReader);
      msg.setTimezone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInteger();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.serializeBinaryToWriter
    );
  }
  f = message.getString();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.serializeBinaryToWriter
    );
  }
  f = message.getList();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.serializeBinaryToWriter
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.serializeBinaryToWriter
    );
  }
  f = message.getBoolean();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.serializeBinaryToWriter
    );
  }
  f = message.getTimezone();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.oneofGroups_ = [[1,2,3,4,5,6,7,8]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  LTE: 3,
  GTE: 4,
  IN: 5,
  NOT_IN: 6,
  BETWEEN: 7,
  EXISTS: 8
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.toObject(includeInstance, f),
    lte: (f = msg.getLte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.toObject(includeInstance, f),
    gte: (f = msg.getGte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.toObject(includeInstance, f),
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.toObject(includeInstance, f),
    between: (f = msg.getBetween()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.deserializeBinaryFromReader);
      msg.setLte(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.deserializeBinaryFromReader);
      msg.setGte(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 6:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 7:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.deserializeBinaryFromReader);
      msg.setBetween(value);
      break;
    case 8:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.serializeBinaryToWriter
    );
  }
  f = message.getLte();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.serializeBinaryToWriter
    );
  }
  f = message.getGte();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.serializeBinaryToWriter
    );
  }
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getBetween();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedInt64(
      1,
      f
    );
  }
};


/**
 * repeated int64 values = 1;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedInt64(
      1,
      f
    );
  }
};


/**
 * repeated int64 values = 1;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: jspb.Message.getFieldWithDefault(msg, 1, 0),
    to: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTo();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 from = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.prototype.getFrom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.prototype.setFrom = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 to = 2;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.prototype.getTo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between.prototype.setTo = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Lte lte = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.getLte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Lte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.setLte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.clearLte = function() {
  return this.setLte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.hasLte = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Gte gte = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.getGte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Gte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.setGte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.clearGte = function() {
  return this.setGte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.hasGte = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional In in = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.hasIn = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional NotIn not_in = 6;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn, 6));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Between between = 7;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.getBetween = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between, 7));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Between|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.setBetween = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.clearBetween = function() {
  return this.setBetween(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.hasBetween = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Exists exists = 8;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists, 8));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer.prototype.hasExists = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.oneofGroups_ = [[1,2,3,4,5,6,7,8]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  IN: 3,
  NOT_IN: 4,
  EXISTS: 5,
  STARTS_WITH: 6,
  ENDS_WITH: 7,
  CONTAINS: 8
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.toObject(includeInstance, f),
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.toObject(includeInstance, f),
    startsWith: (f = msg.getStartsWith()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.toObject(includeInstance, f),
    endsWith: (f = msg.getEndsWith()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.toObject(includeInstance, f),
    contains: (f = msg.getContains()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    case 6:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.deserializeBinaryFromReader);
      msg.setStartsWith(value);
      break;
    case 7:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.deserializeBinaryFromReader);
      msg.setEndsWith(value);
      break;
    case 8:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.deserializeBinaryFromReader);
      msg.setContains(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.serializeBinaryToWriter
    );
  }
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.serializeBinaryToWriter
    );
  }
  f = message.getStartsWith();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.serializeBinaryToWriter
    );
  }
  f = message.getEndsWith();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.serializeBinaryToWriter
    );
  }
  f = message.getContains();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional In in = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.hasIn = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional NotIn not_in = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Exists exists = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.hasExists = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional StartsWith starts_with = 6;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.getStartsWith = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith, 6));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.StartsWith|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.setStartsWith = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.clearStartsWith = function() {
  return this.setStartsWith(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.hasStartsWith = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional EndsWith ends_with = 7;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.getEndsWith = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith, 7));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.EndsWith|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.setEndsWith = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.clearEndsWith = function() {
  return this.setEndsWith(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.hasEndsWith = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Contains contains = 8;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.getContains = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains, 8));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.Contains|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.setContains = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.clearContains = function() {
  return this.setContains(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String.prototype.hasContains = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.oneofGroups_ = [[3,4,5]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.KindCase = {
  KIND_NOT_SET: 0,
  IN: 3,
  NOT_IN: 4,
  EXISTS: 5
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.toObject = function(includeInstance, msg) {
  var f, obj = {
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional In in = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.hasIn = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional NotIn not_in = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Exists exists = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List.prototype.hasExists = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.oneofGroups_ = [[1,2,3,4,5,6,7,8,9]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  LTE: 3,
  GTE: 4,
  IN: 5,
  NOT_IN: 6,
  BETWEEN: 7,
  EXISTS: 8,
  DAYS_AGO: 9
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.toObject(includeInstance, f),
    lte: (f = msg.getLte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.toObject(includeInstance, f),
    gte: (f = msg.getGte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.toObject(includeInstance, f),
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.toObject(includeInstance, f),
    between: (f = msg.getBetween()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.toObject(includeInstance, f),
    daysAgo: (f = msg.getDaysAgo()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.deserializeBinaryFromReader);
      msg.setLte(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.deserializeBinaryFromReader);
      msg.setGte(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 6:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 7:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.deserializeBinaryFromReader);
      msg.setBetween(value);
      break;
    case 8:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    case 9:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.deserializeBinaryFromReader);
      msg.setDaysAgo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.serializeBinaryToWriter
    );
  }
  f = message.getLte();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.serializeBinaryToWriter
    );
  }
  f = message.getGte();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.serializeBinaryToWriter
    );
  }
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getBetween();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.serializeBinaryToWriter
    );
  }
  f = message.getDaysAgo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated google.protobuf.Timestamp values = 1;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    google_protobuf_timestamp_pb.Timestamp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated google.protobuf.Timestamp values = 1;
 * @return {!Array<!proto.google.protobuf.Timestamp>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Timestamp>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {!Array<!proto.google.protobuf.Timestamp>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.google.protobuf.Timestamp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.google.protobuf.Timestamp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp from = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.prototype.getFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp to = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.prototype.getTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between.prototype.hasTo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.toObject = function(includeInstance, msg) {
  var f, obj = {
    operator: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, 0),
    valuesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.Operator} */ (reader.readEnum());
      msg.setOperator(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperator();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.Operator = {
  OPERATOR_UNSPECIFIED: 0,
  OPERATOR_EQ: 1,
  OPERATOR_NEQ: 2,
  OPERATOR_LTE: 3,
  OPERATOR_GTE: 4,
  OPERATOR_BETWEEN: 5
};

/**
 * optional Operator operator = 1;
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.Operator}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.prototype.getOperator = function() {
  return /** @type {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.Operator} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.Operator} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.prototype.setOperator = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 value = 2;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated int32 values = 3;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Lte lte = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.getLte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Lte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.setLte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.clearLte = function() {
  return this.setLte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.hasLte = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Gte gte = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.getGte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Gte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.setGte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.clearGte = function() {
  return this.setGte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.hasGte = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional In in = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.hasIn = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional NotIn not_in = 6;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn, 6));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Between between = 7;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.getBetween = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between, 7));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Between|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.setBetween = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.clearBetween = function() {
  return this.setBetween(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.hasBetween = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Exists exists = 8;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists, 8));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.hasExists = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional DaysAgo days_ago = 9;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.getDaysAgo = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo, 9));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.DaysAgo|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.setDaysAgo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.clearDaysAgo = function() {
  return this.setDaysAgo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date.prototype.hasDaysAgo = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  EXISTS: 3
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool value = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool value = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Exists exists = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean.prototype.hasExists = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.oneofGroups_ = [[1,2,3,4,5,6,7,8]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  LTE: 3,
  GTE: 4,
  IN: 5,
  NOT_IN: 6,
  BETWEEN: 7,
  EXISTS: 8
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.toObject(includeInstance, f),
    lte: (f = msg.getLte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.toObject(includeInstance, f),
    gte: (f = msg.getGte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.toObject(includeInstance, f),
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.toObject(includeInstance, f),
    between: (f = msg.getBetween()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.deserializeBinaryFromReader);
      msg.setLte(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.deserializeBinaryFromReader);
      msg.setGte(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 6:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 7:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.deserializeBinaryFromReader);
      msg.setBetween(value);
      break;
    case 8:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.serializeBinaryToWriter
    );
  }
  f = message.getLte();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.serializeBinaryToWriter
    );
  }
  f = message.getGte();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.serializeBinaryToWriter
    );
  }
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getBetween();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedDouble() : [reader.readDouble()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedDouble(
      1,
      f
    );
  }
};


/**
 * repeated double values = 1;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedDouble() : [reader.readDouble()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedDouble(
      1,
      f
    );
  }
};


/**
 * repeated double values = 1;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    to: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getTo();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double from = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.prototype.getFrom = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.prototype.setFrom = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double to = 2;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.prototype.getTo = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between.prototype.setTo = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Lte lte = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.getLte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Lte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.setLte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.clearLte = function() {
  return this.setLte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.hasLte = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Gte gte = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.getGte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Gte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.setGte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.clearGte = function() {
  return this.setGte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.hasGte = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional In in = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.hasIn = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional NotIn not_in = 6;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn, 6));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Between between = 7;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.getBetween = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between, 7));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Between|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.setBetween = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.clearBetween = function() {
  return this.setBetween(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.hasBetween = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Exists exists = 8;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists, 8));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price.prototype.hasExists = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.oneofGroups_ = [[1,2,3,4,5,6,7,8]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  LTE: 3,
  GTE: 4,
  IN: 5,
  NOT_IN: 6,
  BETWEEN: 7,
  EXISTS: 8
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.toObject(includeInstance, f),
    lte: (f = msg.getLte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.toObject(includeInstance, f),
    gte: (f = msg.getGte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.toObject(includeInstance, f),
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.toObject(includeInstance, f),
    between: (f = msg.getBetween()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.deserializeBinaryFromReader);
      msg.setLte(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.deserializeBinaryFromReader);
      msg.setGte(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 6:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 7:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.deserializeBinaryFromReader);
      msg.setBetween(value);
      break;
    case 8:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.serializeBinaryToWriter
    );
  }
  f = message.getLte();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.serializeBinaryToWriter
    );
  }
  f = message.getGte();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.serializeBinaryToWriter
    );
  }
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getBetween();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string values = 1;
 * @return {!Array<string>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: jspb.Message.getFieldWithDefault(msg, 1, ""),
    to: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string from = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.prototype.getFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.prototype.setFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string to = 2;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.prototype.getTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between.prototype.setTo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Lte lte = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.getLte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Lte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.setLte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.clearLte = function() {
  return this.setLte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.hasLte = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Gte gte = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.getGte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Gte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.setGte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.clearGte = function() {
  return this.setGte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.hasGte = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional In in = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.hasIn = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional NotIn not_in = 6;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn, 6));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Between between = 7;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.getBetween = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between, 7));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Between|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.setBetween = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.clearBetween = function() {
  return this.setBetween(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.hasBetween = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Exists exists = 8;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists, 8));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version.prototype.hasExists = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.oneofGroups_ = [[1,2,3,4,5,6,7,8]];

/**
 * @enum {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.KindCase = {
  KIND_NOT_SET: 0,
  EQ: 1,
  NEQ: 2,
  LTE: 3,
  GTE: 4,
  IN: 5,
  NOT_IN: 6,
  BETWEEN: 7,
  EXISTS: 8
};

/**
 * @return {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.KindCase}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.getKindCase = function() {
  return /** @type {proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.KindCase} */(jspb.Message.computeOneofCase(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.toObject = function(includeInstance, msg) {
  var f, obj = {
    eq: (f = msg.getEq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.toObject(includeInstance, f),
    neq: (f = msg.getNeq()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.toObject(includeInstance, f),
    lte: (f = msg.getLte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.toObject(includeInstance, f),
    gte: (f = msg.getGte()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.toObject(includeInstance, f),
    pb_in: (f = msg.getIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.toObject(includeInstance, f),
    notIn: (f = msg.getNotIn()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.toObject(includeInstance, f),
    between: (f = msg.getBetween()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.toObject(includeInstance, f),
    exists: (f = msg.getExists()) && proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.deserializeBinaryFromReader);
      msg.setEq(value);
      break;
    case 2:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.deserializeBinaryFromReader);
      msg.setNeq(value);
      break;
    case 3:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.deserializeBinaryFromReader);
      msg.setLte(value);
      break;
    case 4:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.deserializeBinaryFromReader);
      msg.setGte(value);
      break;
    case 5:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.deserializeBinaryFromReader);
      msg.setIn(value);
      break;
    case 6:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.deserializeBinaryFromReader);
      msg.setNotIn(value);
      break;
    case 7:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.deserializeBinaryFromReader);
      msg.setBetween(value);
      break;
    case 8:
      var value = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists;
      reader.readMessage(value,proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.deserializeBinaryFromReader);
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEq();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.serializeBinaryToWriter
    );
  }
  f = message.getNeq();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.serializeBinaryToWriter
    );
  }
  f = message.getLte();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.serializeBinaryToWriter
    );
  }
  f = message.getGte();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.serializeBinaryToWriter
    );
  }
  f = message.getIn();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.serializeBinaryToWriter
    );
  }
  f = message.getNotIn();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.serializeBinaryToWriter
    );
  }
  f = message.getBetween();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.serializeBinaryToWriter
    );
  }
  f = message.getExists();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 values = 1;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValues(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 values = 1;
 * @return {!Array<number>}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.prototype.getValuesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: jspb.Message.getFieldWithDefault(msg, 1, 0),
    to: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTo();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 from = 1;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.prototype.getFrom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.prototype.setFrom = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 to = 2;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.prototype.getTo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between.prototype.setTo = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Eq eq = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.getEq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Eq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.setEq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.clearEq = function() {
  return this.setEq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.hasEq = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Neq neq = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.getNeq = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Neq|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.setNeq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.clearNeq = function() {
  return this.setNeq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.hasNeq = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Lte lte = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.getLte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Lte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.setLte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.clearLte = function() {
  return this.setLte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.hasLte = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Gte gte = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.getGte = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Gte|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.setGte = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.clearGte = function() {
  return this.setGte(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.hasGte = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional In in = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.getIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.In|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.setIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.clearIn = function() {
  return this.setIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.hasIn = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional NotIn not_in = 6;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.getNotIn = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn, 6));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.NotIn|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.setNotIn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.clearNotIn = function() {
  return this.setNotIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.hasNotIn = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Between between = 7;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.getBetween = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between, 7));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Between|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.setBetween = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.clearBetween = function() {
  return this.setBetween(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.hasBetween = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Exists exists = 8;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.getExists = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists, 8));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.Exists|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.setExists = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.clearExists = function() {
  return this.setExists(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone.prototype.hasExists = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string application = 2;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.getApplication = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.setApplication = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Integer integer = 10;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.getInteger = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer, 10));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Integer|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.setInteger = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.clearInteger = function() {
  return this.setInteger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.hasInteger = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional String string = 11;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.getString = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String, 11));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.String|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.setString = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.clearString = function() {
  return this.setString(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.hasString = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional List list = 12;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.getList = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List, 12));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.List|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.setList = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.clearList = function() {
  return this.setList(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.hasList = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Date date = 13;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.getDate = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date, 13));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Date|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.setDate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.hasDate = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Boolean boolean = 14;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.getBoolean = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean, 14));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Boolean|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.setBoolean = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.clearBoolean = function() {
  return this.setBoolean(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.hasBoolean = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional Price price = 15;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.getPrice = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price, 15));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Price|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.setPrice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional Version version = 16;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.getVersion = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version, 16));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Version|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.setVersion = function(value) {
  return jspb.Message.setOneofWrapperField(this, 16, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.clearVersion = function() {
  return this.setVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.hasVersion = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional Timezone timezone = 17;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.getTimezone = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone, 17));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.Timezone|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.setTimezone = function(value) {
  return jspb.Message.setOneofWrapperField(this, 17, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.clearTimezone = function() {
  return this.setTimezone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.Tag.prototype.hasTimezone = function() {
  return jspb.Message.getField(this, 17) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    application: jspb.Message.getFieldWithDefault(msg, 2, ""),
    month: jspb.Message.getFieldWithDefault(msg, 3, 0),
    day: jspb.Message.getFieldWithDefault(msg, 4, 0),
    addDays: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch;
  return proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplication(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonth(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDay(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAddDays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApplication();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMonth();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDay();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getAddDays();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string application = 2;
 * @return {string}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.prototype.getApplication = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.prototype.setApplication = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 month = 3;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.prototype.getMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.prototype.setMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 day = 4;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.prototype.getDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.prototype.setDay = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 add_days = 5;
 * @return {number}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.prototype.getAddDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch.prototype.setAddDays = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional Operation operation = 1;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Operation}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.getOperation = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Operation} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Operation, 1));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Operation|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.setOperation = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.pushwoosh.objects.filters.v1.FilterExpression.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.clearOperation = function() {
  return this.setOperation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.hasOperation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Application application = 2;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Application}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.getApplication = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Application} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Application, 2));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Application|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.setApplication = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.pushwoosh.objects.filters.v1.FilterExpression.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.clearApplication = function() {
  return this.setApplication(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.hasApplication = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Tag tag = 3;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.getTag = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Tag, 3));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Tag|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.setTag = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.pushwoosh.objects.filters.v1.FilterExpression.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.clearTag = function() {
  return this.setTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.hasTag = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Geo geo = 4;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Geo}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.getGeo = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Geo} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Geo, 4));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Geo|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.setGeo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.pushwoosh.objects.filters.v1.FilterExpression.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.clearGeo = function() {
  return this.setGeo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.hasGeo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Static static = 5;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Static}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.getStatic = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Static} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Static, 5));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Static|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.setStatic = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.pushwoosh.objects.filters.v1.FilterExpression.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.clearStatic = function() {
  return this.setStatic(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.hasStatic = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Event event = 6;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.getEvent = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Event} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Event, 6));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Event|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.setEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.pushwoosh.objects.filters.v1.FilterExpression.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Updated updated = 7;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.getUpdated = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.Updated, 7));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.Updated|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.setUpdated = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.pushwoosh.objects.filters.v1.FilterExpression.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.clearUpdated = function() {
  return this.setUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.hasUpdated = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional BestTimeToSend best_time_to_send = 8;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.getBestTimeToSend = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend, 8));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.BestTimeToSend|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.setBestTimeToSend = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.pushwoosh.objects.filters.v1.FilterExpression.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.clearBestTimeToSend = function() {
  return this.setBestTimeToSend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.hasBestTimeToSend = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional TagDateMatch tag_date_match = 9;
 * @return {?proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.getTagDateMatch = function() {
  return /** @type{?proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch, 9));
};


/**
 * @param {?proto.pushwoosh.objects.filters.v1.FilterExpression.TagDateMatch|undefined} value
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
*/
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.setTagDateMatch = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.pushwoosh.objects.filters.v1.FilterExpression.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.objects.filters.v1.FilterExpression} returns this
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.clearTagDateMatch = function() {
  return this.setTagDateMatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.objects.filters.v1.FilterExpression.prototype.hasTagDateMatch = function() {
  return jspb.Message.getField(this, 9) != null;
};


goog.object.extend(exports, proto.pushwoosh.objects.filters.v1);
